// Boş kabuk (T00). Gelen kutusu ve paylaşım alımı T03'te gelir.
export function App() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-3 px-6 text-center">
      <h1 className="font-logo text-6xl text-primary">Kalfa</h1>
      <p className="text-muted">Mesaj gelir, kalfa hazırlar, usta onaylar.</p>
    </main>
  )
}
